import classNames from 'classnames';
import React from 'react';
import natwestLoader from '../../assets/img/natwest-loader.gif';
import rbsLoader from '../../assets/img/rbs-loader.gif';
import { useBrand } from '../../providers';
import './Spinner.scss';

interface SpinnerProps {
  message?: string;
  isFullscreen?: boolean;
  isBranded?: boolean;
}

const Spinner: React.FC<SpinnerProps> = ({
  message = 'Loading',
  isFullscreen = false,
  isBranded = false
}) => {
  const { brand } = useBrand();

  return (
    <div
      className={classNames({
        'mss-spinner-wrapper': isFullscreen,
        'mss-spinner-wrapper--branded': isBranded
      })}
      data-cy="loading-indicator"
      data-testid="loading-indicator"
    >
      <div
        className={classNames('zb-loader-block', {
          'mss-spinner-wrapper__loader': isFullscreen,
          'zb-loader-block-inverted': isFullscreen && !isBranded
        })}
      >
        <div className="zb-loader-content">
          {isBranded ? (
            <span className="mss-spinner__logo">
              <img src={(brand === 'natwest' ? natwestLoader : rbsLoader) as string} alt="" />
            </span>
          ) : (
            <span className="zb-loader" />
          )}
          <span className="zb-loader-text">{message}</span>
        </div>
      </div>
    </div>
  );
};

export default Spinner;
